const serviceAreas = [
  {
    serviceArea: 'Maintenance',
    enabled: true,
    i18nTranslationKey: 'maintenance',
  },
  {
    serviceArea: 'Quality',
    enabled: false,
    i18nTranslationKey: 'quality',
  },
  {
    serviceArea: 'Department Manager',
    enabled: false,
    i18nTranslationKey: 'departmentManager',
  },
];
const serviceActions = [
  {
    serviceArea: 'Maintenance',
    item: 'Line Down',
    itemValue: 'Line Down',
    enabled: true,
    i18nTranslationKey: 'lineDown',
  },
  {
    serviceArea: 'Maintenance',
    item: 'Machine Down',
    itemValue: 'Machine Down',
    enabled: true,
    i18nTranslationKey: 'machineDown',
  },
  {
    serviceArea: 'Maintenance',
    item: 'Planned Repair (<5 hrs)',
    itemValue: 'Planned Repair',
    enabled: true,
    i18nTranslationKey: 'plannedRepair',
  },
  {
    serviceArea: 'Quality',
    item: 'Default',
    itemValue: 'Default',
    enabled: true,
    i18nTranslationKey: 'default',
  },
  {
    serviceArea: 'Department Manager',
    item: 'Default',
    itemValue: 'Default',
    enabled: true,
    i18nTranslationKey: 'default',
  },
];
export { serviceAreas, serviceActions };
